// src/firebase.js
import { getApp, getApps, initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyCVzBLjfqdKI4wGRleBgQV6pduhGFEqFxk",
  authDomain: "ukconnect-9ac81.firebaseapp.com",
  projectId: "ukconnect-9ac81",
  storageBucket: "ukconnect-9ac81.firebasestorage.app",
  messagingSenderId: "319348914652",
  appId: "1:319348914652:web:aa4b8c97600199f7c47719",
  measurementId: "G-SNW15EDHDS"
};

export const mirrorFirebaseConfig = {
  apiKey: "AIzaSyDaflopUVbx5Gh2FBZAjhzc7l7EUjLttBA",
  authDomain: "kyetech-data.firebaseapp.com",
  projectId: "kyetech-data",
  storageBucket: "kyetech-data.firebasestorage.app",
  messagingSenderId: "795074700634",
  appId: "1:795074700634:web:f1dee28a2868e25243ff63",
  measurementId: "G-G5RMHXWQJ7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const mirrorAppName = "kyetech-mirror";
const mirrorApp = getApps().some((appInstance) => appInstance.name === mirrorAppName)
  ? getApp(mirrorAppName)
  : initializeApp(mirrorFirebaseConfig, mirrorAppName);

// Export Firebase services
export const auth = getAuth(app);
export const authReady = setPersistence(auth, browserLocalPersistence).catch(() => undefined);
export const db = getFirestore(app);
export const mirrorDb = getFirestore(mirrorApp);

export async function isMirrorTransactionsEnabled() {
  try {
    const settingsSnap = await getDoc(doc(db, "settings", "packages"));
    return settingsSnap.exists() ? settingsSnap.data().mirrorTransactionsEnabled ?? true : true;
  } catch {
    return true;
  }
}
